import { render, staticRenderFns } from "./ConfigSubProdutoEdit.vue?vue&type=template&id=3391e180"
import script from "./ConfigSubProdutoEdit.vue?vue&type=script&lang=js"
export * from "./ConfigSubProdutoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports